"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityObserver = void 0;
var custom_observer_1 = require("./custom-observer");
var vue_model_observability_1 = require("./vue-model-observability");
/**
 * A subclass of Vue's internal `Observer` class for entities, which uses model
 * metadata to manage property access/change rather than property walking and rewriting
 */
var EntityObserver = /** @class */ (function (_super) {
    __extends(EntityObserver, _super);
    function EntityObserver(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        return _super.call(this, value, shallow, mock) || this;
    }
    EntityObserver.prototype.ensureObservable = function () {
        if (this._observable === true) {
            return;
        }
        this.value.accessed.subscribe(this._onAccess.bind(this));
        this.value.changed.subscribe(this._onChange.bind(this));
        if (this.value.meta) {
            (0, vue_model_observability_1.getObjectMetaObserver)(this.value.meta).ensureObservable();
        }
        this._observable = true;
    };
    EntityObserver.prototype._onAccess = function (args) {
        // Get the current property value
        var value = args.entity.__fields__[args.property.name];
        // Notify interested observers of the property access in order to track dependencies
        this.onPropertyAccess(args.property.name, value);
    };
    EntityObserver.prototype._onChange = function (args) {
        // Get the current property value
        var newValue = args.entity.__fields__[args.property.name];
        // Notify interested observers of the property change
        this.onPropertyChange(args.property.name, newValue);
    };
    return EntityObserver;
}(custom_observer_1.CustomObserver));
exports.EntityObserver = EntityObserver;
